import { clearPath } from '@/components/shared/Breadcrumbs/heplers'

export const state = () => ({
  breadcrumbs: null,
})

export const mutations = {
  setBreadcrumbs: (state, payload) => {
    state.breadcrumbs = [...payload].map(({ title, path }) => {
      return {
        title,
        path: clearPath(path),
      }
    })
  },
}

export const getters = {
  breadcrumbs: state => state.breadcrumbs || [],
}
